import { render, staticRenderFns } from "./footer0.vue?vue&type=template&id=2c2af9c4&scoped=true"
import script from "./footer0.vue?vue&type=script&lang=js"
export * from "./footer0.vue?vue&type=script&lang=js"
import style0 from "./footer0.vue?vue&type=style&index=0&id=2c2af9c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2af9c4",
  null
  
)

export default component.exports